// extracted by mini-css-extract-plugin
export default {"chipContainer":"multiAutocomplete_component_chipContainer__bjnon"};